"use strict";

export const smallScreenBreakpoint: string = "600px";
export const mediumScreenBreakpoint: string = "900px";
